module.exports = __webpack_public_path__ + "6a3aade332d459bdcfce52377c2cb2cc.svg";